import './tabs.scss'

import CustomHTMLElement from 'html-element'

class Tabs extends CustomHTMLElement {}
window.customElements.define('tab-buttons', Tabs)
